<template>
	<div class="twinkle-twinkle">
		<speaker-notes :notes="notes"></speaker-notes>
		<h2>... into this?</h2>
		<music-display :abc="twinkle" :has-audio="true" :large="true"></music-display>
	</div>
</template>

<script>
	import MusicDisplay from "../components/MusicDisplay";
	import {formatMusic} from "../helpers/format-music";
	import { mapGetters } from 'vuex';
	import SpeakerNotes from "../components/SpeakerNotes";

	export default {
		name: "twinkle-twinkle",
		components: {SpeakerNotes, MusicDisplay},
		data() {
			return {
				twinkle: formatMusic(this.simpleMusic()),
				notes: [
					"What if we can manually construct an audio buffer on the fly?",
					"Fast, and sounds reasonably good?",
					"Requires few resources, especially when playing the second song?",
					"Notice when I click play the spinner that replaces the play button.",
					"Here's what it sounds like (click play).",
				],
			}
		},
		methods: {
			...mapGetters(['simpleMusic']),
		},
	}
</script>

<style lang="scss" scoped>
	.twinkle-twinkle {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: calc(100% - 15px);
	}
</style>
